import { TReduxActions } from '../../actions';
import { ISaveSearch } from '../../types/saveSearch';
import { ESaveSearchActionType } from '../../actions/saveSearch';

const defaultState: ISaveSearch = {
  isOpen: false,
};

export function saveSearchReducer(state: ISaveSearch = defaultState, action: TReduxActions): ISaveSearch {
  switch (action.type) {
    case ESaveSearchActionType.ModalOpened:
      return {
        ...state,
        isOpen: true,
      };
    case ESaveSearchActionType.ModalClosed:
      return {
        ...state,
        isOpen: false,
      };
  }

  return state;
}
